/* @luxottica/vto-microservices v2.2.0 */
import { RemoteLogConfig } from '@luxottica/vm-remotelog';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

const envHost = {
  STAGING: 'https://test-gateway-vtoprofile.luxdeepblue.com',
  ACCEPTANCE: 'https://acceptance-gateway-vtoprofile.luxdeepblue.com',
  PRODUCTION: 'https://gateway-vtoprofile.luxdeepblue.com'
};
const envMap = {
  STAGING: {
    loginFaUrl: `${envHost.STAGING}/auth/fradv/token`,
    loginVmUrl: `${envHost.STAGING}/auth/vm/token`,
    refreshUrl: `${envHost.STAGING}/auth/refresh`,
    bipaTextUrl: `${envHost.STAGING}/services/vtobipams/public/v2/bipa/version`,
    bipaSubmitFormUrl: `${envHost.STAGING}/services/vtobipams/public/v1/bipa-consent`,
    videoSessionUrl: `${envHost.STAGING}/services/vtovideoprofilems/public/v3/video`,
    enrichUrl: `${envHost.STAGING}/services/vtovideoprofilems/public/v1/ml-enrich`,
    vtoUrl: `${envHost.STAGING}/services/vtovideoprofilems/public/v1/basel-mesh`,
    additionalInfoUrl: `${envHost.STAGING}/services/vtovideoprofilems/public/v1/additional-info`,
    poseExtractionUrl: `${envHost.STAGING}/services/vtovideoprofilems/public/v1/poses-extraction`,
    statusUrl: `${envHost.STAGING}/services/vtovideoprofilems/public/v2/status`,
    pdStatusUrl: `${envHost.STAGING}/services/vtomedicalinfoms/public/v1/pupillary-distance/status`,
    profileUrl: `${envHost.STAGING}/services/vtovideoprofilems/public/v3/get-video-profile`
  },
  ACCEPTANCE: {
    loginFaUrl: `${envHost.ACCEPTANCE}/auth/fradv/token`,
    loginVmUrl: `${envHost.ACCEPTANCE}/auth/vm/token`,
    refreshUrl: `${envHost.ACCEPTANCE}/auth/refresh`,
    bipaTextUrl: `${envHost.ACCEPTANCE}/services/vtobipams/public/v2/bipa/version`,
    bipaSubmitFormUrl: `${envHost.ACCEPTANCE}/services/vtobipams/public/v1/bipa-consent`,
    videoSessionUrl: `${envHost.ACCEPTANCE}/services/vtovideoprofilems/public/v3/video`,
    enrichUrl: `${envHost.ACCEPTANCE}/services/vtovideoprofilems/public/v1/ml-enrich`,
    vtoUrl: `${envHost.ACCEPTANCE}/services/vtovideoprofilems/public/v1/basel-mesh`,
    additionalInfoUrl: `${envHost.ACCEPTANCE}/services/vtovideoprofilems/public/v1/additional-info`,
    poseExtractionUrl: `${envHost.ACCEPTANCE}/services/vtovideoprofilems/public/v1/poses-extraction`,
    statusUrl: `${envHost.ACCEPTANCE}/services/vtovideoprofilems/public/v2/status`,
    pdStatusUrl: `${envHost.ACCEPTANCE}/services/vtomedicalinfoms/public/v1/pupillary-distance/status`,
    profileUrl: `${envHost.ACCEPTANCE}/services/vtovideoprofilems/public/v3/get-video-profile`
  },
  PRODUCTION: {
    loginFaUrl: `${envHost.PRODUCTION}/auth/fradv/token`,
    loginVmUrl: `${envHost.PRODUCTION}/auth/vm/token`,
    refreshUrl: `${envHost.PRODUCTION}/auth/refresh`,
    bipaTextUrl: `${envHost.PRODUCTION}/services/vtobipams/public/v2/bipa/version`,
    bipaSubmitFormUrl: `${envHost.PRODUCTION}/services/vtobipams/public/v1/bipa-consent`,
    videoSessionUrl: `${envHost.PRODUCTION}/services/vtovideoprofilems/public/v3/video`,
    enrichUrl: `${envHost.PRODUCTION}/services/vtovideoprofilems/public/v1/ml-enrich`,
    vtoUrl: `${envHost.PRODUCTION}/services/vtovideoprofilems/public/v1/basel-mesh`,
    additionalInfoUrl: `${envHost.PRODUCTION}/services/vtovideoprofilems/public/v1/additional-info`,
    poseExtractionUrl: `${envHost.PRODUCTION}/services/vtovideoprofilems/public/v1/poses-extraction`,
    statusUrl: `${envHost.PRODUCTION}/services/vtovideoprofilems/public/v2/status`,
    pdStatusUrl: `${envHost.PRODUCTION}/services/vtomedicalinfoms/public/v1/pupillary-distance/status`,
    profileUrl: `${envHost.PRODUCTION}/services/vtovideoprofilems/public/v3/get-video-profile`
  }
};

const getConfig = (env, param) => {
  return envMap[env][param];
};

class MicroserviceError extends Error {
  constructor(type, message, error) {
    super(message);
    this.type = type;
    this.name = type;
    this.message = message;
    this.stack = error === null || error === void 0 ? void 0 : error.stack;
    Object.setPrototypeOf(this, MicroserviceError.prototype);
  }

}

class EnvironmentError extends MicroserviceError {
  constructor(env) {
    super(EnvironmentError.type, `microservice environment ${env} is not valid`);
    this.env = env;
    Object.setPrototypeOf(this, EnvironmentError.prototype);
  }

}

EnvironmentError.type = 'EnvironmentError';

class InvalidInputError extends MicroserviceError {
  constructor(message, error) {
    super(InvalidInputError.type, message, error);
    Object.setPrototypeOf(this, InvalidInputError.prototype);
  }

}

InvalidInputError.type = 'InputError';

class LocaleError extends MicroserviceError {
  constructor(locale) {
    super(LocaleError.type, `bipa agreement text cannot be found for locale ${locale}`);
    this.locale = locale;
    Object.setPrototypeOf(this, LocaleError.prototype);
  }

}

LocaleError.type = 'LocaleError';

class RequestError extends MicroserviceError {
  constructor(message, error) {
    super(RequestError.type, message, error);
    Object.setPrototypeOf(this, RequestError.prototype);
  }

}

RequestError.type = 'RequestError';

class TimeoutError extends MicroserviceError {
  constructor(duration) {
    super(TimeoutError.type, `request has timed out after ${duration}ms`);
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }

}

TimeoutError.type = 'TimeoutError';

const name = "@luxottica/vto-microservices";
const version = "2.2.0";

const logger = RemoteLogConfig.getInstance().getLoggerInfo(name, version, 'RequestHelper');

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const pollPromise = (interval, timeout, promise, shouldCancel) => {
  let completed = false;
  const startTime = Date.now();
  return new Promise(async (resolve, reject) => {
    while (true) {
      if (completed) {
        return;
      }

      if (shouldCancel()) {
        return;
      }

      if (Date.now() - startTime > timeout) {
        reject(new TimeoutError(timeout));
        return;
      }

      await promise().then(result => {
        completed = true;
        resolve(result);
      }).catch(() => {
        logger.debug('continue poll');
      });
      await delay(interval);
    }
  });
};

const pollProcessingStatus = (request, url, entryTypes) => {
  return fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${request.accessToken}`,
      'accept': '*/*'
    }
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('FAILED POLL');
    }
  }).then(json => {
    logger.debug(json);
    const pollingEntry = json.filter(entry => {
      return entryTypes.includes(entry.type);
    });

    if (pollingEntry.length > 0) {
      const complete = pollingEntry.every(entry => ['OK', 'KO'].includes(entry.progress));
      const success = pollingEntry.every(entry => entry.progress === 'OK');

      if (complete) {
        return success;
      } else {
        throw new Error('processing incomplete');
      }
    } else {
      throw new Error('processing incomplete');
    }
  }).catch(err => {
    logger.debug(err);
    throw err;
  });
};

const parseJsonResponse = response => {
  if (response.ok) {
    return response.json();
  } else {
    return response.json().catch(() => {
      throw new Error(`${response.status}: ${response.statusText}`);
    }).then(json => {
      throw new Error(JSON.stringify(json));
    });
  }
};

const refreshRequest = request => {
  const url = getConfig(request.environment, 'refreshUrl');
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      refresh_token: request.refreshToken
    })
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      return response.json().catch(() => {
        throw new Error(`${response.status}: ${response.statusText}`);
      }).then(json => {
        throw new Error(JSON.stringify(json));
      });
    }
  }).then(json => {
    // logger.debug(json);
    const refreshReturn = {
      accessToken: json.access_token,
      refreshToken: json.refresh_token
    };

    if (!!request.onAuthUpdated) {
      request.onAuthUpdated(refreshReturn);
    }

    return refreshReturn;
  }).catch(err => {
    // logger.error(err);
    throw err;
  });
};

const bipaAgreementFetch = request => {
  const bipaAgreementUrl = getConfig(request.environment, 'bipaTextUrl');
  return fetch(bipaAgreementUrl, {
    method: 'GET',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    }
  });
};

const bipaAgreementRequest = request => {
  let bipaVersion;
  let bipaDescription;
  return bipaAgreementFetch(request).then(bipaAgreementResponse => {
    if (bipaAgreementResponse.status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return bipaAgreementFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return bipaAgreementResponse;
    }
  }).then(response => {
    return parseJsonResponse(response);
  }).then(json => {
    bipaVersion = json.version;
    bipaDescription = json.description;
    const bipaUrls = JSON.parse(json.jsonUrl);

    if (!!bipaUrls[request.locale]) {
      return fetch(bipaUrls[request.locale]);
    } else {
      throw new LocaleError(request.locale);
    }
  }).then(response => {
    return parseJsonResponse(response);
  }).then(bipaAgreementResponse => {
    return {
      version: bipaVersion,
      description: bipaDescription,
      text: bipaAgreementResponse.BIPA_AGREEMENT
    };
  });
};

const submitBipaFormFetch = request => {
  const bipaSubmitUrl = getConfig(request.environment, 'bipaSubmitFormUrl');
  return fetch(bipaSubmitUrl, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    },
    body: `{ "bipaVersion": ${request.bipaVersion}, "channel": "${request.source}", "firstName": "${request.firstName}", "lastName": "${request.lastName}", "email": "${request.email}" }`
  });
};

const submitBipaFormRequest = request => {
  return submitBipaFormFetch(request).then(submitBipaResponse => {
    if (submitBipaResponse.status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return submitBipaFormFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return submitBipaResponse;
    }
  });
};

const profileFetch = request => {
  const url = getConfig(request.environment, 'profileUrl');
  return fetch(`${url}/${request.videoId}`, {
    method: 'GET',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    }
  });
};

const profileRequest = request => {
  return profileFetch(request).then(profileResponse => {
    if (profileResponse.status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return profileFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return profileResponse;
    }
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      return response.json().catch(() => {
        throw new Error(`${response.status}: ${response.statusText}`);
      }).then(json => {
        throw new Error(JSON.stringify(json));
      });
    }
  }).then(json => {
    const result = {};
    result['properties'] = json.mlInformations;
    result['videoId'] = json.uuid;
    return result;
  });
};

const uploadImageFetch = request => {
  const form = new FormData();
  form.append('file', new File([request.img], 'take0.jpg', {
    type: 'image/jpeg'
  }));
  return fetch(`${request.uploadPath}/take0.jpg`, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      Authorization: `Bearer ${request.accessToken}`
    },
    body: form
  });
};

const processImageFetch = request => {
  const mlUrl = getConfig(request.environment, 'enrichUrl');
  const vtoUrl = getConfig(request.environment, 'vtoUrl');
  return Promise.all([request.enableMachineLearning ? fetch(mlUrl, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    },
    'body': `{ "uuid": "${request.videoId}" }`
  }) : undefined, request.enableVto ? fetch(vtoUrl, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    },
    'body': `{ "uuid": "${request.videoId}" }`
  }) : undefined]);
};

const uploadImageRequest = request => {
  return uploadImageFetch(request).then(uploadImageResponse => {
    if (uploadImageResponse.status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return uploadImageFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return uploadImageResponse;
    }
  }).then(response => {
    if (response.ok) {
      return;
    } else {
      return response.json().catch(() => {
        throw new Error(`${response.status}: ${response.statusText}`);
      }).then(json => {
        throw new Error(JSON.stringify(json));
      });
    }
  });
};

const uploadImageDataRequest = request => {
  return new Promise((resolve, reject) => {
    const w = request.imgData.width;
    const h = request.imgData.height;
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');

    if (!!ctx) {
      ctx.putImageData(request.imgData, 0, 0);
      canvas.toBlob(blob => {
        if (!!blob) {
          resolve(blob);
        } else {
          reject(new RequestError('failed to extract image from canvas'));
        }
      }, 'image/jpeg', 0.95);
    } else {
      reject(new RequestError('failed to extract image from canvas'));
    }
  }).then(imgBlob => {
    return uploadImageRequest(_objectSpread2(_objectSpread2({}, request), {}, {
      img: imgBlob
    }));
  });
};

const processImageRequest = request => {
  if (!request.enableMachineLearning && !request.enableVto) {
    return Promise.reject(new InvalidInputError('enableMachineLearning and enableVto cannot both be set to false'));
  }

  return processImageFetch(request).then(processImageResponse => {
    if (!!processImageResponse[0] && processImageResponse[0].ok && processImageResponse[0].status === 401 || !!processImageResponse[1] && processImageResponse[1].ok && processImageResponse[1].status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return processImageFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return processImageResponse;
    }
  }).then(response => {
    if ((response[0] === undefined || response[0].ok) && (response[1] === undefined || response[1].ok)) {
      const promises = [];
      const entries = [];

      if (request.enableVto) {
        entries.push('BASEL_MESH');
      }

      if (request.enableMachineLearning) {
        entries.push('ML_INFORMATION');
        const pdStatusUrl = `${getConfig(request.environment, 'pdStatusUrl')}/${request.videoId}`;
        promises.push(pollPromise(1000, 30000, () => pollProcessingStatus(request, pdStatusUrl, ['PD']), request.shouldCancel));
      }

      const statusUrl = `${getConfig(request.environment, 'statusUrl')}/${request.videoId}`;
      promises.push(pollPromise(1000, 30000, () => pollProcessingStatus(request, statusUrl, entries), request.shouldCancel));
      return Promise.all(promises).then(results => results.every(result => !!result));
    } else {
      throw new RequestError(`failed to poll status with sessionId=${request.videoId}`);
    }
  }).then(success => {
    if (success) {
      return profileRequest(request);
    } else {
      throw new RequestError(`failed to poll status with sessionId=${request.videoId}`);
    }
  });
};

const loginRequest = request => {
  if (!!request.accessToken && !!request.refreshToken) {
    return Promise.resolve({
      accessToken: request.accessToken,
      refreshToken: request.refreshToken
    });
  } else {
    const loginType = request.version === 1 ? 'loginVmUrl' : 'loginFaUrl';
    const url = getConfig(request.environment, loginType);
    return fetch(url, {
      method: 'POST',
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        rememberMe: true
      })
    }).then(response => {
      if (response.ok) {
        return response.json();
      } else {
        return response.json().catch(() => {
          throw new Error(`${response.status}: ${response.statusText}`);
        }).then(json => {
          throw new Error(JSON.stringify(json));
        });
      }
    }).then(json => {
      var _a;

      const authData = {
        accessToken: json.access_token,
        refreshToken: json.refresh_token
      };
      (_a = request.onAuthUpdated) === null || _a === void 0 ? void 0 : _a.call(request, authData);
      return authData;
    });
  }
};

const sessionFetch = request => {
  const url = getConfig(request.environment, 'videoSessionUrl');
  return fetch(url, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    },
    body: `{ "region": "${request.region}", "source": "${request.source}"}`
  });
};

const sessionRequest = request => {
  return sessionFetch(request).then(sessionResponse => {
    if (sessionResponse.status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return sessionFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return sessionResponse;
    }
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else {
      return response.json().catch(() => {
        throw new Error(`${response.status}: ${response.statusText}`);
      }).then(json => {
        throw new Error(JSON.stringify(json));
      });
    }
  }).then(json => {
    return {
      videoId: json.uuid,
      uploadPath: json.uploadBasePath
    };
  });
};

const uploadVideoFetch = request => {
  const form = new FormData();
  const mimeType = `video/${request.fileType}`;
  form.append('file', new File(request.video, `videoTake.${request.fileType}`, {
    type: mimeType
  }));
  return fetch(`${request.uploadPath}/videoTake.${request.fileType}`, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      Authorization: `Bearer ${request.accessToken}`
    },
    body: form
  }).then(response => {
    const url = getConfig(request.environment, 'additionalInfoUrl');

    if (response.ok) {
      return fetch(`${url}/${request.videoId}`, {
        method: 'PUT',
        headers: {
          'Accept': '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${request.accessToken}`
        },
        'body': `{ "mimeType": "${mimeType}" }`
      });
    } else {
      const e = new Error('failed to upload');
      throw e;
    }
  });
};

const processVideoFetch = request => {
  const mlUrl = getConfig(request.environment, 'enrichUrl');
  const vtoUrl = getConfig(request.environment, 'poseExtractionUrl');
  return Promise.all([request.enableMachineLearning ? fetch(mlUrl, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    },
    'body': `{ "uuid": "${request.videoId}" }`
  }) : undefined, request.enableVto ? fetch(vtoUrl, {
    method: 'POST',
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${request.accessToken}`
    },
    'body': `{ "uuid": "${request.videoId}" }`
  }) : undefined]);
};

const uploadVideoRequest = request => {
  return uploadVideoFetch(request).then(uploadVideoResponse => {
    if (uploadVideoResponse.status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return uploadVideoFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return uploadVideoResponse;
    }
  }).then(response => {
    if (response.ok) {
      return;
    } else {
      return response.json().catch(() => {
        throw new Error(`${response.status}: ${response.statusText}`);
      }).then(json => {
        throw new Error(JSON.stringify(json));
      });
    }
  });
};

const processVideoRequest = request => {
  if (!request.enableMachineLearning && !request.enableVto) {
    return Promise.reject(new InvalidInputError('enableMachineLearning and enableVto cannot both be set to false'));
  }

  return processVideoFetch(request).then(processVideoResponse => {
    if (!!processVideoResponse[0] && processVideoResponse[0].ok && processVideoResponse[0].status === 401 || !!processVideoResponse[1] && processVideoResponse[1].ok && processVideoResponse[1].status === 401) {
      return refreshRequest(request).then(refreshResponse => {
        return processVideoFetch(_objectSpread2(_objectSpread2({}, request), {}, {
          accessToken: refreshResponse.accessToken,
          refreshToken: refreshResponse.refreshToken
        }));
      });
    } else {
      return processVideoResponse;
    }
  }).then(response => {
    if ((response[0] === undefined || response[0].ok) && (response[1] === undefined || response[1].ok)) {
      const promises = [];
      const entries = ['POSES_EXTRACTION'];

      if (request.enableVto) {
        entries.push('BASEL_MESH');
      }

      if (request.enableMachineLearning) {
        entries.push('ML_INFORMATION');
        const pdStatusUrl = `${getConfig(request.environment, 'pdStatusUrl')}/${request.videoId}`;
        promises.push(pollPromise(1000, 30000, () => pollProcessingStatus(request, pdStatusUrl, ['PD']), request.shouldCancel));
      }

      const statusUrl = `${getConfig(request.environment, 'statusUrl')}/${request.videoId}`;
      promises.push(pollPromise(1000, 30000, () => pollProcessingStatus(request, statusUrl, entries), request.shouldCancel));
      return Promise.all(promises).then(results => results.every(result => !!result));
    } else {
      throw new RequestError(`failed to poll status with sessionId=${request.videoId}`);
    }
  }).then(success => {
    if (success) {
      return profileRequest(request);
    } else {
      throw new RequestError(`failed to poll status with sessionId=${request.videoId}`);
    }
  });
};

export { bipaAgreementRequest, loginRequest, processImageRequest, processVideoRequest, sessionRequest, submitBipaFormRequest, uploadImageDataRequest, uploadImageRequest, uploadVideoRequest };
//# sourceMappingURL=vto-microservices.js.map
